import {Input, Button, Table, DatePicker, Image, Popconfirm, message} from "antd";
import locale from 'antd/es/date-picker/locale/zh_CN';
import React, {useEffect, useState} from "react";
import {SearchOutlined} from '@ant-design/icons';
import './index.sass'
import api from "../../utils/api";
import UserInfo from "../../components/UserInfo";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";
import {searchDecode, searchEncode} from "../../utils/functions";
import moment from "moment";

const TAB_VISITOR = 0;
const TAB_USER_FANS = 1;
const TAB_MERCHANT_FANS = 2;
const TAB_FORBIDDEN = 3;
const TAB_USER_FORBIDDEN = 4;
const TAB_MERCHANT_FORBIDDEN = 5;
const MERCHANT_FANS = 'MERCHANT';
const USER_FANS = 'USER';
const PAGE_SIZE = 15;

const Tabs = (props) => {
    return (
        <div className='change_fans'>
            <ul className='flex tabs'>
                <li className={props.currentTab === TAB_USER_FANS ? 'active' : ''} onClick={() => {
                    props.changeTab(TAB_USER_FANS);
                }} key={TAB_USER_FANS}>我的粉丝
                </li>
                <li className={props.currentTab === TAB_MERCHANT_FANS ? 'active' : ''} onClick={() => {
                    props.changeTab(TAB_MERCHANT_FANS);
                }} key={TAB_MERCHANT_FANS}>我的商户
                </li>
                <li className={props.currentTab >= TAB_FORBIDDEN ? 'active' : ''} onClick={() => {
                    props.changeTab(TAB_FORBIDDEN);
                }} key={TAB_FORBIDDEN}>我屏蔽的
                </li>
            </ul>
        </div>
    );
};
const UsersColumns = [
    {
        title: '昵称',
        key: "nickname",
        render: (ctx) => {
            return ctx !== undefined && ctx['nickname'] ? (<> {ctx.avatar ? (
                <Image src={ctx.avatar} width={40}/>
            ) : ""} {ctx['nickname']}</>) : '游客' + ctx['id']
        }
    },
    {
        title: '联系方式',
        key: "mobile",
        render: (ctx) => {
            return ctx !== undefined && ctx['mobile'] ? ctx['mobile'] : '--'
        }
    },
    {
        title: '关注时间',
        dataIndex: '',
        key: 'followed_at',
    },
];

const MerchantColumns = [
    {
        title: '昵称',
        key: "name",
        render: (ctx) => {
            return ctx !== undefined && ctx['name'] ? (<>{ctx.avatar ? (
                <Image src={ctx.avatar} width={40}/>
            ) : ""} {ctx['name']}</>) : '游客' + ctx['id']
        }
    },
    {
        title: '联系方式',
        key: "mobile",
        render: (ctx) => {
            return ctx !== undefined && ctx['mobile'] ? ctx['mobile'] : '--'
        }
    },
    {
        title: '粉丝数量',
        dataIndex: '',
        key: 'fans_count',
    },
    {
        title: '销售金额',
        dataIndex: '',
        key: 'sales_amount',
    },
    {
        title: '关注时间',
        dataIndex: '',
        key: 'followed_at',
    },
];

const UserFansComponent = (props) => {
    let {page, totalNum, searchCallback, dataSource, search, currentTab, forbidden} = props;
    if (currentTab !== TAB_USER_FANS) {
        return null;
    }
    const columns = [...UsersColumns, {
        title: '操作',
        fixed: 'right',
        render: (ctx) => {
            return (
                <div className='flex'>
                    <Popconfirm
                        title='确认屏蔽用户'
                        cancelText='取消'
                        okText='确认'
                        onConfirm={(ctx) => {
                            forbidden(ctx['id'], ctx['nickname'] ? ctx['nickname'] : '游客' + ctx['id']);
                        }}>
                        <div className='warn pointer'>屏蔽</div>
                    </Popconfirm>
                </div>
            )
        }
    }]
    return (<div className="userFans">
        <Table dataSource={dataSource} columns={columns} rowKey={record => record.id}/>
    </div>);
}

const MerchantFansComponent = (props) => {
    let {page, totalNum, searchCallback, dataSource, search, currentTab, forbidden} = props;
    if (currentTab !== TAB_MERCHANT_FANS) {
        return null;
    }
    const columns = [...MerchantColumns, {
        title: '操作',
        fixed: 'right',
        render: (ctx) => {
            return (
                <div className='flex'>
                    <Popconfirm
                        title='确认屏蔽用户'
                        cancelText='取消'
                        okText='确认'
                        onConfirm={(ctx) => {
                            forbidden(ctx['id'], ctx['name'] ? ctx['name'] : '游客' + ctx['id']);
                        }}>
                        <div className='warn pointer'>屏蔽</div>
                    </Popconfirm>
                </div>
            )
        }
    },];
    return (<div className="merchantFans">
        <Table dataSource={dataSource} columns={columns} rowKey={record => record.id}/>
    </div>);
}

const ForbiddenComponent = (props) => {
    let {page, totalNum, searchCallback, dataSource, search, currentTab, changeTab, unForbidden} = props;
    if (currentTab !== TAB_FORBIDDEN && currentTab !== TAB_MERCHANT_FORBIDDEN && currentTab !== TAB_USER_FORBIDDEN) {
        return null;
    }
    const columns = [...(currentTab === TAB_MERCHANT_FORBIDDEN ? MerchantColumns : UsersColumns), {
        title: '操作',
        fixed: 'right',
        render: (ctx) => {
            return (
                <div className='flex'>
                    <Popconfirm
                        title='确认取消屏蔽用户'
                        cancelText='取消'
                        okText='确认'
                        onConfirm={(ctx) => {
                            if (currentTab === TAB_MERCHANT_FORBIDDEN) {
                                unForbidden(ctx['id'], ctx['name'] ? ctx['name'] : '游客' + ctx['id']);
                            } else {
                                unForbidden(ctx['id'], ctx['nickname'] ? ctx['nickname'] : '游客' + ctx['id']);
                            }
                        }}>
                        <div className='warn pointer'>取消屏蔽</div>
                    </Popconfirm>
                </div>
            )
        }
    },];

    return (<div className="merchantFans">
        <ul className='flex alignCenter shield mgb10'>
            <li onClick={() => {
                changeTab(TAB_USER_FORBIDDEN)
            }}
                className={currentTab === TAB_FORBIDDEN || currentTab === TAB_USER_FORBIDDEN ? 'active' : ''}
                key={TAB_USER_FORBIDDEN}>屏蔽的用户
            </li>
            <li onClick={() => {
                changeTab(TAB_MERCHANT_FORBIDDEN)
            }}
                className={currentTab === TAB_MERCHANT_FORBIDDEN ? 'active' : ''}
                key={TAB_MERCHANT_FORBIDDEN}>屏蔽的商户
            </li>
        </ul>
        <Table dataSource={dataSource} columns={columns} rowKey={record => record.id}/>
    </div>);
}
const DATE_FORMAT = 'YYYY-MM-DD';
const SearchComponent = (props) => {
    let {search, searchCallback} = props;
    const [name, setName] = useState(search['name']);

    const [joinedAt, setJoinedAt] = useState(search['join_at'] ? moment(search['join_at'], DATE_FORMAT) : null);

    useEffect((arg) => {
        setName(search['name']);
        setJoinedAt(search['join_at'] ? moment(search['join_at'], DATE_FORMAT) : null);
    }, [search]);
    return (
        <div className='change_fans flex'>
            <div className='flex line alignCenter'>
                搜索昵称：
                <Input placeholder='搜索昵称：' value={name} onChange={(e) => {
                    setName(e.target.value)
                }}/>
            </div>
            <div className='flex line alignCenter'>
                关注时间：
                <DatePicker value={joinedAt} onChange={(e, d) => {
                    setJoinedAt(e)
                }} locale={locale}/>
            </div>
            <Button onClick={() => {
                let search = {name: name, join_at: joinedAt ? joinedAt.format(DATE_FORMAT) : null};
                searchCallback(search);
            }} icon={<SearchOutlined/>}>搜索</Button>
            <Button>重置</Button>
        </div>
    );
}

class UserList extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            currentTab: TAB_USER_FANS,
            currentPage: 1,
            dataSource: [],
            searchQuery: {
                name: '',
                join_at: null
            },
        }
        this.init(props);
    }

    componentWillMount () {
        if (this.props.token.value) {
            this.loadData();
        }
    }

    shouldComponentUpdate (nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value || nextProps.location.search !== this.props.location.search) {
            this.init(nextProps);
        }
        return nextState !== this.state || nextProps !== this.props;
    }

    init (nextProps = null) {
        if (nextProps) {
            const query = new URLSearchParams(nextProps.location.search);
            let search = query.get('search');
            let searchQuery = {};
            if (search) {
                search = searchDecode(search);
                for (const key in search) {
                    searchQuery[search[key]['name']] = search[key]['val'];
                }
            }
            let tab = query.get('current_tab');
            let page = query.get('page')
            this.setState({
                currentTab: parseInt(tab ? tab : TAB_USER_FANS),
                currentPage: parseInt(page ? page : 1),
                search: query.get('search'),
                searchQuery: searchQuery
            }, () => {
                this.loadData();
            });
        } else {
            this.loadData();
        }
    }

    loadData = () => {
        switch (this.state.currentTab) {
            case TAB_USER_FANS:
                this.getUserFans()
                break;
            case TAB_MERCHANT_FANS:
                this.getMerchantFans();
                break;
            case TAB_FORBIDDEN:
            case TAB_USER_FORBIDDEN:
                this.getForbiddenUserFans()
                break;
            case TAB_MERCHANT_FORBIDDEN:
                this.getForbiddenMerchantFans();
                break;
        }
    }

    changeTab = (tab) => {
        this.setState({
            currentTab: tab
        });
        this.props.history.push({
            search: "current_tab=" + tab + '&page=1'
        });
    }
    getUserFans = async () => {//我的粉丝
        let {search} = this.state;
        if (!search) {
            search = searchEncode([{name: 'name', rule: '!=', val: ''}]);
        }
        let param = {}
        if (search) {
            param['search'] = search
        }
        let res = await api('get-user-fans', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
    }

    getMerchantFans = async () => {//我的商户
        let {search} = this.state;
        let param = {}
        if (search) {
            param['search'] = search
        }
        let res = await api('get-merchant-fans', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
    }


    getForbiddenUserFans = async () => {//屏蔽的用户
        let {search} = this.state;
        let param = {}

        if (search) {
            param['search'] = search
        }
        let res = await api('get-forbidden-user-fans', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
    }

    getForbiddenMerchantFans = async () => {//屏蔽的商户
        let {search} = this.state;
        let param = {}

        if (search) {
            param['search'] = search
        }
        let res = await api('get-forbidden-merchant-fans', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
    }

    unForbiddenFans = async (id, name) => {
        let {currentTab} = this.state
        let param = {
            fans_id: id,
        }
        switch (currentTab) {
            case TAB_FORBIDDEN:
            case TAB_MERCHANT_FORBIDDEN:
                param['fans_type'] = MERCHANT_FANS;
                break;
            case TAB_USER_FORBIDDEN:
                param['fans_type'] = USER_FANS;
                break;
            default:
                return;
        }
        let res = await api('un-forbidden-fans', param);
        if (res.code === 200) {
            message.success('已经取消对' + name + '屏蔽！');
            this.init();
        } else {
            message.error(res.message)
        }
    }

    forbiddenFans = async (id, name) => {//屏蔽用户
        let {currentTab} = this.state
        let param = {
            fans_id: id,
        }
        switch (currentTab) {
            case TAB_MERCHANT_FANS:
                param['fans_type'] = MERCHANT_FANS;
                break;
            case TAB_USER_FANS:
                param['fans_type'] = USER_FANS;
                break;
            default:
                return;
        }
        let res = await api('forbidden-fans', param);
        if (res.code === 200) {
            message.success('已经屏蔽' + name + '！');
            this.init();
        } else {
            message.error(res.message)
        }
    }

    searchCallback = async (search) => {
        let searchStruct = [
            {name: 'name', val: search['name'], rule: "like"},
            {name: 'join_at', val: search['join_at'], rule: "="}
        ]
        let query = searchEncode(searchStruct);
        this.props.history.push({
            search: "current_tab=" + this.state.currentTab + '&page=' + this.state.currentPage + '&search=' + query
        });
    }

    render () {
        let {currentTab} = this.state;
        const HeaderRight = () => {
            let [merchant] = useState(this.props.merchant);
            return <ul className='flex census'>
                <li>
                    <label>全部商户</label>
                    <p>{merchant.merchantFansCount}</p>
                </li>
                <li>
                    <label>全部粉丝</label>
                    <p>{merchant.userFansCount}</p>
                </li>
            </ul>;
        }
        return (
            <div className='userList' token={this.props.token.value}>
                <UserInfo rightBox={<HeaderRight/>}/>
                {/* 头部 */}

                <div className='record'>
                    <Tabs changeTab={this.changeTab} currentTab={currentTab}/>
                    <SearchComponent search={this.state.searchQuery} searchCallback={(search) => {
                        this.searchCallback(search)
                    }}/>
                    <div className='change_fans'>
                        <UserFansComponent
                            currentTab={this.state.currentTab}
                            dataSource={this.state.dataSource}
                            search={this.state.search}
                            forbidden={(id, name) => {
                                this.forbiddenFans(id, name);
                            }}/>
                        <MerchantFansComponent
                            currentTab={this.state.currentTab}
                            dataSource={this.state.dataSource}
                            search={this.state.search}
                            forbidden={(id, name) => {
                                this.forbiddenFans(id, name);
                            }}/>
                        <ForbiddenComponent
                            changeTab={(tab) => {
                                this.changeTab(tab);
                            }}
                            currentTab={this.state.currentTab}
                            dataSource={this.state.dataSource}
                            search={this.state.search}
                            unForbidden={(id, name) => {
                                this.unForbiddenFans(id, name);
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(UserList);